import React, { useMemo } from 'react'
import MealCategoryForm from './_form'

export default function MealCategoryAdd (props) {
  const data = useMemo(() => ({ active: false }), [])
  return (
    <MealCategoryForm mode='add' data={data} {...props} />
  )
}